import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const Printdata = () => {
  const { state } = useLocation();

  // 🔹 Start & End time from user
  const [startTime, setStartTime] = useState("");
  const [endTime, setEndTime] = useState("");

  // 🔹 Filtered data
  const [filteredState, setFilteredState] = useState(state || []);

  // 🔹 Handle print event (optional)
  useEffect(() => {
    const afterPrint = () => {};
    window.addEventListener("afterprint", afterPrint);
    return () => window.removeEventListener("afterprint", afterPrint);
  }, []);

  // 🔹 Apply filter
  const applyFilter = () => {
    if (startTime === "" || endTime === "") {
      setFilteredState(state);
      return;
    }

    const filtered = state?.filter(
      (s) => Number(s[17]) >= startTime && Number(s[17]) <= endTime
    );

    setFilteredState(filtered);
  };
  const clearFilter = () => {
    setStartTime("");
    setEndTime("");
    setFilteredState(state);
  };

  return (
    <>
      {/* 🔹 PRINT BUTTON */}
      <div className="filter-card no-print">
        <h3>⏰ Time Filter</h3>

        <div className="filter-row">
          <select
            value={startTime}
            onChange={(e) => setStartTime(Number(e.target.value))}
          >
            <option value="">Start Time</option>
            {[...Array(24)].map((_, i) => (
              <option key={i} value={i}>
                {i}:00
              </option>
            ))}
          </select>

          <select
            value={endTime}
            onChange={(e) => setEndTime(Number(e.target.value))}
          >
            <option value="">End Time</option>
            {[...Array(24)].map((_, i) => (
              <option key={i} value={i}>
                {i}:00
              </option>
            ))}
          </select>

          <button className="btn apply" onClick={applyFilter}>
            Apply
          </button>

          <button className="btn clear" onClick={clearFilter}>
            Clear
          </button>

          <button className="btn print" onClick={() => window.print()}>
            Print
          </button>
        </div>
      </div>

      {/* 🔹 PRINT CONTENT */}
      <p style={{ fontSize: "1.5vh", fontWeight: "bold" }} className="pr">
        {filteredState?.map((s, index) => (
          <span key={index}>
            {s[13]}-{s[17]}-{index + 1}-{s[3]}-{s[2]}-{s[4]}-{s[9]}
            <br />
          </span>
        ))}
      </p>

      {/* 🔹 PRINT-ONLY CSS */}
      <style>
        {`
          @media print {
            .no-print {
              display: none;
            }
          }
             .filter-card {
          background: #ffffff;
          padding: 15px;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          margin-bottom: 20px;
        }

        .filter-row {
          display: flex;
          gap: 10px;
          align-items: center;
          flex-wrap: wrap;
        }

        select {
          padding: 8px;
          border-radius: 6px;
          border: 1px solid #ccc;
        }

        .btn {
          padding: 8px 14px;
          border-radius: 6px;
          border: none;
          cursor: pointer;
          font-weight: bold;
        }

        .apply {
          background: #2563eb;
          color: white;
        }

        .clear {
          background: #ef4444;
          color: white;
        }

        .print {
          background: #16a34a;
          color: white;
        }
        `}
      </style>
    </>
  );
};

export default Printdata;
